import { useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import ExamContext from 'context/exam.context';
import Exam from 'components/Exam';
import DashboardContainer from 'components/Layouts/Dashboard/DashboardContainer';
import { SIDEBAR_EXAM } from 'constant';
import ExamControllerContext from 'context/examController.context';
import { call } from 'utils/caller';

function ExamPage() {
  const history = useHistory();
  const [exams] = useContext(ExamContext);
  const [{ examId, isStart, isReady }, dispatch] = useContext(
    ExamControllerContext
  );

  const childRef = useRef();
  const finishRedirectPathRef = useRef(null);

  const nextExamId = useMemo(() => {
    const currentExamIndex = exams.findIndex(
      (exam) => exam.paket_ujian.idUj === examId
    );
    if (currentExamIndex < 0) return null;

    const nextExam = exams[currentExamIndex + 1];

    return nextExam?.paket_ujian.idUj ?? null;
  }, [examId, exams]);

  // Menangani apabila peserta menjawab/mengubah jawaban.
  const handleAnswerChange = useCallback(
    (newAnswer) => {
      call(dispatch.answer, newAnswer);
    },
    [dispatch.answer]
  );

  // Menangani apabila peserta ingin menyelesaikan ujian.
  const handleFinish = useCallback(() => {
    finishRedirectPathRef.current =
      nextExamId != null
        ? `/dashboard?next_exam_id=${nextExamId}`
        : '/dashboard';
    call(dispatch.finish);
  }, [dispatch.finish, nextExamId]);

  // Memindahkan halaman ketika belum ada ujian yang dimulai.
  useEffect(() => {
    if (exams.length === 0 || !isStart) {
      // Memindahkan ke halaman dashboard apabila data exam belum diambil.
      history.replace(finishRedirectPathRef.current || '/dashboard');
      finishRedirectPathRef.current = null;
    }
  }, [exams.length, history, isStart]);

  return (
    <DashboardContainer activeSidebarItem={SIDEBAR_EXAM} showProfileOnSidebar>
      {!isReady ? (
        <>Loading...</>
      ) : (
        <Exam
          ref={childRef}
          onAnswerChange={handleAnswerChange}
          onFinish={handleFinish}
        />
      )}
    </DashboardContainer>
  );
}

export default ExamPage;
